"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = void 0;
var defaultProps = {
  items: [],
  onChange: undefined,
  selected: undefined
};
exports.defaultProps = defaultProps;